import { BaselineFuelType, EquipmentType, Program, TBaselineFuelTypeId, TProgramId } from '/src/lib/models';

export type TEquipmentCategoryId = number;

export interface EquipmentCategory {
  id: TEquipmentCategoryId;
  name: string;
  program_id: TProgramId;
  baseline_fuel_type_id: TBaselineFuelTypeId;
  program?: Program;
  baseline_fuel_type?: BaselineFuelType;
  equipment_types?: EquipmentType[];
}

export enum EquipmentCategoryId {
  CA_LCFS_LIGHT_DUTY_FCI = 133,
  CA_LCFS_HEAVY_DUTY_FCI = 134,
  OR_CFP_LIGHT_DUTY_FCI = 135,
  OR_CFP_HEAVY_DUTY_FCI = 136,
  WA_CFS_LIGHT_DUTY_FCI = 137,
  WA_CFS_HEAVY_DUTY_FCI = 138,
}

export const fciEquipmentCategories: Set<number> = new Set([
  EquipmentCategoryId.CA_LCFS_LIGHT_DUTY_FCI,
  EquipmentCategoryId.CA_LCFS_HEAVY_DUTY_FCI,
  EquipmentCategoryId.OR_CFP_LIGHT_DUTY_FCI,
  EquipmentCategoryId.OR_CFP_HEAVY_DUTY_FCI,
  EquipmentCategoryId.WA_CFS_LIGHT_DUTY_FCI,
  EquipmentCategoryId.WA_CFS_HEAVY_DUTY_FCI,
]);

export const isFciCategory = (equipmentCategoryId?: TEquipmentCategoryId | null): boolean =>
  equipmentCategoryId != null && fciEquipmentCategories.has(equipmentCategoryId);
